// extracted by mini-css-extract-plugin
module.exports = {"grid":"WarrantyFilterSection_grid__2HKzc","fullWidth":"WarrantyFilterSection_fullWidth__fgpBX"};